import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import Button from '../../../../generic-components/Button';
import { LiliTransaction } from '../../types/lili-transaction';
import { useDownloadCheckPhotoMutation } from '../../../../hooks/mutations/useDownloadCheckPhotoMutation';
import { useStore } from '../../../../store';
import { ReactComponent as RightErrorIcon } from '../../../../assets/svg/right-white-arrow.svg';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
  transaction: LiliTransaction;
  onClose: () => void;
}

enum ECheckTypes {
  FRONT = 0,
  REAR = 1,
}

export const CheckReviewPopup = ({ transaction, onClose }: IProps) => {
  const { customerId } = useStore((state) => state.user);
  const {
    data: frontPhoto,
    mutate: getFrontPhoto,
    isLoading,
  } = useDownloadCheckPhotoMutation({
    customerId,
    transactionId: transaction?.checkDetailsData?.checkTransactionId || '',
    checkSide: true,
  });
  const { data: rearPhoto, mutate: getRearPhoto } = useDownloadCheckPhotoMutation({
    customerId,
    transactionId: transaction?.checkDetailsData?.checkTransactionId || '',
    checkSide: false,
  });
  const [activeCheckType, setActiveCheckType] = useState<ECheckTypes>(ECheckTypes.FRONT);

  useEffect(() => {
    if (!transaction.transactionId) return;
    Promise.all([getFrontPhoto(), getRearPhoto()]);
  }, [transaction.transactionId]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className='fixed inset-0 bg-bw08 bg-opacity-75 backdrop-blur-sm z-[9999] flex flex-col items-center justify-center'
      onClick={onClose}
    >
      <div className='absolute top-0 py-[20px] px-[15px] z-50 w-full bg-bw08 rounded-b-[6px]'>
        <div className='flex justify-between'>
          <div className='text-bw00 font-metricR text-[16px]'>View Check</div>
          <div>
            <div className='flex'>
              <CloseButton
                onClick={onClose}
                className='ml-[20px]'
                id='exitCheckPopup'
                color={CloseButtonColor.White}
                size={CloseButtonSize.Large}
              />
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Skeleton width='400px' height='600px' />
      ) : (
        <div className='bg-white relative w-[50%] max-w-[50%] max-h-[70%] flex items-center justify-center pt-[80px]'>
          {activeCheckType === ECheckTypes.FRONT && (
            <Button
              onClick={() => setActiveCheckType(ECheckTypes.REAR)}
              title=''
              id='navigateRearPhoto'
              childElement={<RightErrorIcon className='w-full h-full' />}
              className='absolute py-[10px] px-[10px] right-0 translate-x-[calc(100%+65px)] w-[40px] h-[40px] bg-bw08 rounded-[50%]'
            />
          )}
          {activeCheckType === ECheckTypes.FRONT && (
            <img className='object-contain w-full h-full fadeIn' src={frontPhoto} alt='Front Check' />
          )}
          {activeCheckType === ECheckTypes.REAR && (
            <Button
              onClick={() => setActiveCheckType(ECheckTypes.FRONT)}
              title=''
              id='navigateRearPhoto'
              childElement={<RightErrorIcon className='w-full h-full rotate-180' />}
              className='absolute py-[10px] px-[10px] left-0 translate-x-[calc(-100%-65px)] w-[40px] h-[40px] bg-bw08 rounded-[50%]'
            />
          )}
          {activeCheckType === ECheckTypes.REAR && (
            <img className='object-contain w-full h-full fadeIn' src={rearPhoto} alt='Rear Check' />
          )}
        </div>
      )}
    </div>
  );
};
